import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import InputText from "../../components/form-control/input-text";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { AxiosError } from "axios";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { FileUpload } from "primereact/fileupload";
import { errorHandler } from "../../utils/HelperFunctions";
import useToast from "../../components/common/useToast";
import apiFunctions from "../../services/api-service";
import { Select, Spin } from "antd";
import cryptoHelper from "../../libs/password";
import { useJsApiLoader } from "@react-google-maps/api";

const { Option } = Select;

const GOOGLE_LIBRARIES: ("places")[] = ["places"];

type PlaceValue = {
    placeId: string;
    formattedAddress: string;
    name: string;
    latitude: number | null;
    longitude: number | null;
} | null;

const RegistrationCreateGu: React.FC = () => {
    const { showToast }: any = useToast();
    const navigate = useNavigate();

    const [fetchingSubcast, setFetchingSubcast] = useState(false);
    const [fetchingSurname, setFetchingSurname] = useState(false);
    const [fetchingSubAdmin, setFetchingSubAdmin] = useState(false);
    const [rows] = useState(20);

    const [surname, setSurname] = useState<any[]>([]);
    const [firstSurname, setFirstSurname] = useState(0);
    const [totalRecordsSurname, setTotalRecordsSurname] = useState(0);
    const [surnameSearchValue, setSurnameSearchValue] = useState("");

    const [subcast, setSubcast] = useState<any[]>([]);
    const [firstSubcast, setFirstSubcast] = useState(0);
    const [totalRecordsSubcast, setTotalRecordsSubcast] = useState(0);
    const [subcastSearchValue, setSubcastSearchValue] = useState("");

    const [subAdmin, setSubAdmin] = useState<any[]>([]);
    const [firstSubAdmin, setFirstSubAdmin] = useState(0);
    const [totalRecordsSubAdmin, setTotalRecordsSubAdmin] = useState(0);
    const [subAdminSearchValue, setSubAdminSearchValue] = useState("");

    const nativeVillageInputRef = useRef<HTMLInputElement | null>(null);
    const currentVillageInputRef = useRef<HTMLInputElement | null>(null);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY || "",
        libraries: GOOGLE_LIBRARIES,
    });

    const maritalOptions = [
        { label: "Single", value: "Single" },
        { label: "Engaged", value: "Engaged" },
        { label: "Married", value: "Married" },
        { label: "Divorced", value: "Divorced" },
        { label: "Widower", value: "Widower" },
    ];

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("નામ જરૂરી છે!"),
        gujaratiName: Yup.string().required("નામ (ગુજરાતી) જરૂરી છે!"),
        fatherName: Yup.string().required("પિતાનું નામ જરૂરી છે!"),
        gujaratiFatherName: Yup.string().required("પિતાનું નામ (ગુજરાતી) જરૂરી છે!"),
        mobile: Yup.string()
            .required("મોબાઈલ નંબર જરૂરી છે!")
            .matches(/^[0-9]{10}$/, "માન્ય 10-અંક નંબર દાખલ કરો"),
        gender: Yup.string().required("લિંગ જરૂરી છે!"),
        dateOfBirth: Yup.date().required("જન્મ તારીખ જરૂરી છે!"),
        maritalStatus: Yup.string().required("લગ્ન સ્થિતિ જરૂરી છે!"),
        subCast: Yup.string().required("ઉપ જાતિ જરૂરી છે!"),
        surname: Yup.string().required("અટક જરૂરી છે!"),
        nativeVillage: Yup.object().nullable().required("મૂળ ગામ જરૂરી છે!"),
        currentVillage: Yup.object().nullable().required("વર્તમાન ગામ જરૂરી છે!"),
        password: Yup.string()
            .required("પાસવર્ડ જરૂરી છે!")
            .min(6, "પાસવર્ડ ઓછામાં ઓછા 6 અક્ષરોનો હોવો જોઈએ!"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password")], "પાસવર્ડ મેળ ખાતા નથી!")
            .required("પાસવર્ડ પુષ્ટિ જરૂરી છે!"),
        subAdmin: Yup.string().required("સબ-એડમિન જરૂરી છે!"),
        profilePic: Yup.mixed().required("પ્રોફાઇલ પિક્ચર જરૂરી છે!"),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            gujaratiName: "",
            fatherName: "",
            gujaratiFatherName: "",
            subCast: "",
            surname: "",
            gender: "",
            dateOfBirth: null,
            maritalStatus: "",
            nativeVillage: null as PlaceValue,
            currentVillage: null as PlaceValue,
            mobile: "",
            password: "",
            confirmPassword: "",
            subAdmin: "",
            profilePic: null,
            identityFront: null,
            identityBack: null,
            adharno: "",
        },

        validationSchema,

        onSubmit: async (values: any) => {

            let pass: any = cryptoHelper.generatePassword(values.password);
            let encodedPassword = encodeURIComponent(pass);

            const payload = {
                approver: values.subAdmin, // assuming subAdmin is approver ID
                currentaddress: values.currentVillage, // Google Places object
                dob: values.dateOfBirth, // format as yyyy-mm-dd if needed
                fathername: values.fatherName,
                fathernamegujarati: values.gujaratiFatherName,
                gender: values.gender,
                identitybackimg: values.identityBack?.name || "", // file name or empty string
                identityfrontimg: values.identityFront?.name || "",
                maritalstatus: values.maritalStatus,
                mobileno: values.mobile,
                name: values.name,
                namegujarati: values.gujaratiName,
                nativeaddress: values.nativeVillage, // Google Places object
                otp: "", // generate or leave empty
                password: encodedPassword,
                profileimg: values.profilePic || "",
                subcastid: values.subCast, // map to backend subcast ID
                surnameid: values.surname, // map to backend surname ID
                doa: "", // if you have Date of Anniversary
                devicetoken: "", // if any device token
                noverification: true,
                adharno: values.adharno || "",
            };

            await apiFunctions
                .post(`/usermobile/mobile/register`, payload)
                .then((response) => {
                    if (response?.data?.success) {
                        formik.resetForm();
                        showToast({
                            severity: "success",
                            summary: "Success",
                            detail: response.data.message,
                            life: 3000,
                        });
                    } else {
                        showToast({
                            severity: "error",
                            summary: "Error",
                            detail: response.data.message,
                            life: 3000,
                        });
                    }
                })
                .catch((err: AxiosError) => {
                    if (err.status === 401) {
                        localStorage.clear();
                        navigate("/guregister");
                    }
                    errorHandler(err);
                })
                .finally(() => {
                    navigate("/guregister");
                });
        },
    });

    // Google Places autocomplete on Native Village / Current Village fields
    useEffect(() => {
        if (!isLoaded) return;
        const timer = setTimeout(() => {
            if (nativeVillageInputRef.current) {
                const autocomplete = new (window as any).google.maps.places.Autocomplete(
                    nativeVillageInputRef.current
                );
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    if (!place.place_id) return;
                    formik.setFieldValue("nativeVillage", {
                        placeId: place.place_id,
                        formattedAddress: place.formatted_address || place.name || "",
                        name: place.name || place.formatted_address || "",
                        latitude: place.geometry?.location?.lat() ?? null,
                        longitude: place.geometry?.location?.lng() ?? null,
                    });
                });
            }
            if (currentVillageInputRef.current) {
                const autocomplete = new (window as any).google.maps.places.Autocomplete(
                    currentVillageInputRef.current
                );
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    if (!place.place_id) return;
                    formik.setFieldValue("currentVillage", {
                        placeId: place.place_id,
                        formattedAddress: place.formatted_address || place.name || "",
                        name: place.name || place.formatted_address || "",
                        latitude: place.geometry?.location?.lat() ?? null,
                        longitude: place.geometry?.location?.lng() ?? null,
                    });
                });
            }
        }, 100);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded]);

    const fetchSubadmin = async (reset = false) => {
        if (fetchingSubAdmin) return;
        setFetchingSubAdmin(true);
        const start = reset ? 0 : firstSubAdmin;
        try {
            const response = await apiFunctions.get(
                `/subadminmobile/mobile/getapproverlist/${start}/${rows}/${subAdminSearchValue || ''}`
            );

            const newItems = response?.data?.data || [];
            const total = response?.data?.totalRecords || 0;

            if (reset) {
                setSubAdmin(newItems);
                setFirstSubAdmin(rows);
            } else {
                setSubAdmin(prev => [...prev, ...newItems]);
                setFirstSubAdmin(prev => prev + rows);
            }

            setTotalRecordsSubAdmin(total);
        } finally {
            setFetchingSubAdmin(false);
        }
    };

    useEffect(() => {
        setFirstSubAdmin(0);
        fetchSubadmin(true);   // Fetch dependent data if needed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subAdminSearchValue]);

    const handleSubAdminScroll = (e: any) => {
        const { scrollTop, offsetHeight, scrollHeight } = e.target;

        const nearBottom = scrollTop + offsetHeight >= scrollHeight - 10;
        const moreToLoad = subAdmin.length < totalRecordsSubAdmin;
        if (nearBottom && moreToLoad && !fetchingSubAdmin) {
            fetchSubadmin();
        }
    };

    const handleSubAdminSearch = (value: any) => {
        setSubAdminSearchValue(value);
    };

    const fetchSubcast = async (reset = false) => {
        if (fetchingSubcast) return;
        setFetchingSubcast(true);
        const start = reset ? 0 : firstSubcast;
        try {
            const response = await apiFunctions.get(
                `/subcastmobile/mobile/allsubcast/${start}/${rows}/${subcastSearchValue || ''}`
            );

            const newItems = response?.data?.data || [];
            const total = response?.data?.totalRecords || 0;

            if (reset) {
                setSubcast(newItems);
                setFirstSubcast(rows);
            } else {
                setSubcast(prev => [...prev, ...newItems]);
                setFirstSubcast(prev => prev + rows);
            }

            setTotalRecordsSubcast(total);
        } finally {
            setFetchingSubcast(false);
        }
    };

    useEffect(() => {
        setFirstSubcast(0);
        fetchSubcast(true);   // Fetch dependent data if needed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subcastSearchValue]);

    const handleSubcastScroll = (e: any) => {
        const { scrollTop, offsetHeight, scrollHeight } = e.target;

        const nearBottom = scrollTop + offsetHeight >= scrollHeight - 10;
        const moreToLoad = subcast.length < totalRecordsSubcast;
        if (nearBottom && moreToLoad && !fetchingSubcast) {
            fetchSubcast();
        }
    };

    const handleSubcastSearch = (value: any) => {
        setSubcastSearchValue(value);
    };

    const fetchSurname = async (reset = false) => {
        if (fetchingSurname) return;
        setFetchingSurname(true);
        const start = reset ? 0 : firstSurname;
        try {
            const response = await apiFunctions.get(
                `/surnamemobile/mobile/allsurname/${formik.values.subCast}/${start}/${rows}/${surnameSearchValue || ''}`
            );

            const newItems = response?.data?.data || [];
            const total = response?.data?.totalRecords || 0;

            if (reset) {
                setSurname(newItems);
                setFirstSurname(rows);
            } else {
                setSurname(prev => [...prev, ...newItems]);
                setFirstSurname(prev => prev + rows);
            }

            setTotalRecordsSurname(total);
        } finally {
            setFetchingSurname(false);
        }
    };

    useEffect(() => {
        if (formik.values.subCast) {
            setFirstSurname(0);
            fetchSurname(true);   // Fetch dependent data if needed
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surnameSearchValue, formik.values.subCast]);

    const handleSurnameScroll = (e: any) => {
        const { scrollTop, offsetHeight, scrollHeight } = e.target;

        const nearBottom = scrollTop + offsetHeight >= scrollHeight - 10;
        const moreToLoad = surname.length < totalRecordsSurname;

        if (nearBottom && moreToLoad && !fetchingSurname) {
            fetchSurname();
        }
    };

    const handleSurnameSearch = (value: any) => {
        setSurnameSearchValue(value);
    };

    return (
        <div className="standalone-page-bg">
            <div className="page-title">
                <h3>નોંધણી બનાવો</h3>
            </div>

            <form onSubmit={formik.handleSubmit}>
                <Card className="grid form-layout p-4">
                    <div className="grid grid-cols-12 gap-4">

                        {/* NAME */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="નામ"
                                id="name"
                                modelValue={formik.values.name}
                                validation={
                                    formik.errors.name &&
                                    formik.touched.name && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.name },
                                    }
                                }
                                onUpdateModelValue={(val: string) => formik.setFieldValue("name", val)}
                            />
                        </div>

                        {/* GUJARATI NAME */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="નામ (ગુજરાતી)"
                                id="gujaratiName"
                                modelValue={formik.values.gujaratiName}
                                validation={
                                    formik.errors.gujaratiName &&
                                    formik.touched.gujaratiName && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.gujaratiName },
                                    }
                                }
                                onUpdateModelValue={(val: string) =>
                                    formik.setFieldValue("gujaratiName", val)
                                }
                            />
                        </div>

                        {/* FATHER NAME */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="પિતાનું નામ"
                                id="fatherName"
                                modelValue={formik.values.fatherName}
                                validation={
                                    formik.errors.fatherName &&
                                    formik.touched.fatherName && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.fatherName },
                                    }
                                }
                                onUpdateModelValue={(val: string) =>
                                    formik.setFieldValue("fatherName", val)
                                }
                            />
                        </div>

                        {/* GUJARATI FATHER NAME */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="પિતાનું નામ (ગુજરાતી)"
                                id="gujaratiFatherName"
                                modelValue={formik.values.gujaratiFatherName}
                                validation={
                                    formik.errors.gujaratiFatherName &&
                                    formik.touched.gujaratiFatherName && {
                                        $error: true,
                                        required: {
                                            $invalid: true,
                                            $message: formik.errors.gujaratiFatherName,
                                        },
                                    }
                                }
                                onUpdateModelValue={(val: string) =>
                                    formik.setFieldValue("gujaratiFatherName", val)
                                }
                            />
                        </div>

                        {/* SUBCAST */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">ઉપ જાતિ</label>
                            <Select
                                style={{ width: "100%", height: "40px" }}
                                showSearch
                                allowClear
                                placeholder="ઉપ જાતિ પસંદ કરો"
                                value={formik.values.subCast}
                                onChange={(val) => formik.setFieldValue("subCast", val)}
                                filterOption={false}
                                status={
                                    formik.touched.subCast && formik.errors.subCast
                                        ? "error"
                                        : ""
                                }
                                onSearch={handleSubcastSearch}
                                onPopupScroll={handleSubcastScroll}
                                notFoundContent={fetchingSubcast ? <Spin size="small" /> : 'No data'}
                            >
                                {subcast.map((item: any) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                            {formik.touched.subCast && typeof formik.errors.subCast === "string" && (
                                <small className="text-red-500">{formik.errors.subCast}</small>
                            )}
                        </div>

                        {/* SURNAME */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">ઉપનામ</label>
                            <Select
                                style={{ width: "100%", height: "40px" }}
                                showSearch
                                allowClear
                                placeholder="ઉપનામ પસંદ કરો"
                                value={formik.values.surname}
                                filterOption={false}
                                status={
                                    formik.touched.surname && formik.errors.surname
                                        ? "error"
                                        : ""
                                }
                                onSearch={handleSurnameSearch}
                                onPopupScroll={handleSurnameScroll}
                                notFoundContent={fetchingSurname ? <Spin size="small" /> : 'No data'}
                                onChange={(val) => formik.setFieldValue("surname", val)}
                            >
                                {surname.map((item: any) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                            {formik.touched.surname && typeof formik.errors.surname === "string" && (
                                <small className="text-red-500">{formik.errors.surname}</small>
                            )}
                        </div>

                        {/* GENDER */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">લિંગ</label>
                            <div className="flex gap-4 mt-2">
                                <div>
                                    <RadioButton
                                        inputId="male"
                                        value="Male"
                                        onChange={(e) => formik.setFieldValue("gender", e.value)}
                                        checked={formik.values.gender === "Male"}
                                    />
                                    <label htmlFor="male" className="ml-2">
                                        પુરુષ
                                    </label>
                                </div>
                                <div>
                                    <RadioButton
                                        inputId="female"
                                        value="Female"
                                        onChange={(e) => formik.setFieldValue("gender", e.value)}
                                        checked={formik.values.gender === "Female"}
                                    />
                                    <label htmlFor="female" className="ml-2">
                                        સ્ત્રી
                                    </label>
                                </div>
                            </div>
                            {formik.touched.gender && typeof formik.errors.gender === "string" && (
                                <small className="text-red-500">{formik.errors.gender}</small>
                            )}
                        </div>

                        {/* DATE OF BIRTH */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">જન્મ તારીખ</label>
                            <Calendar
                                className="w-full mt-1"
                                value={formik.values.dateOfBirth}
                                dateFormat="dd-mm-yy"
                                onChange={(e) => formik.setFieldValue("dateOfBirth", e.value)}
                            />
                            {formik.touched.dateOfBirth && typeof formik.errors.dateOfBirth === "string" && (
                                <small className="text-red-500">{formik.errors.dateOfBirth}</small>
                            )}
                        </div>

                        {/* MARITAL STATUS */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">વિવાહિત સ્થિતિ</label>
                            <Select
                                style={{ width: "100%", height: "40px" }}
                                allowClear
                                placeholder="વિવાહિત સ્થિતિ પસંદ કરો"
                                value={formik.values.maritalStatus}
                                onChange={(val) => formik.setFieldValue("maritalStatus", val)}
                                filterOption={false}
                                status={
                                    formik.touched.maritalStatus && formik.errors.maritalStatus
                                        ? "error"
                                        : ""
                                }
                            >
                                {maritalOptions.map((item) => (
                                    <Option key={item.value} value={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                            {formik.touched.maritalStatus &&
                                typeof formik.errors.maritalStatus === "string" && (
                                    <small className="text-red-500">{formik.errors.maritalStatus}</small>
                                )}
                        </div>

                        {/* NATIVE VILLAGE — Google Places autocomplete */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">મૂળ ગામ</label>
                            <input
                                ref={nativeVillageInputRef}
                                type="text"
                                placeholder="મૂળ ગામ શોધો..."
                                defaultValue={formik.values.nativeVillage?.formattedAddress || ""}
                                className="w-full mt-1 border rounded px-3"
                                style={{ height: "40px" }}
                            />
                            {formik.touched.nativeVillage &&
                                typeof formik.errors.nativeVillage === "string" && (
                                    <small className="text-red-500">{formik.errors.nativeVillage}</small>
                                )}
                        </div>

                        {/* CURRENT VILLAGE — Google Places autocomplete */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">વર્તમાન ગામ</label>
                            <input
                                ref={currentVillageInputRef}
                                type="text"
                                placeholder="વર્તમાન ગામ શોધો..."
                                defaultValue={formik.values.currentVillage?.formattedAddress || ""}
                                className="w-full mt-1 border rounded px-3"
                                style={{ height: "40px" }}
                            />
                            {formik.touched.currentVillage &&
                                typeof formik.errors.currentVillage === "string" && (
                                    <small className="text-red-500">{formik.errors.currentVillage}</small>
                                )}
                        </div>

                        {/* MOBILE */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="મોબાઇલ નંબર"
                                id="mobile"
                                modelValue={formik.values.mobile}
                                onUpdateModelValue={(val) => formik.setFieldValue("mobile", val)}
                                validation={
                                    formik.errors.mobile &&
                                    formik.touched.mobile && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.mobile },
                                    }
                                }
                            />
                        </div>

                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="text"
                                label="આધાર નંબર"
                                id="adharno"
                                modelValue={formik.values.adharno}
                                onUpdateModelValue={(val) => formik.setFieldValue("adharno", val)}
                                validation={
                                    formik.errors.adharno &&
                                    formik.touched.adharno && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.adharno },
                                    }
                                }
                            />
                        </div>

                        {/* PASSWORD */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="password"
                                label="પાસવર્ડ"
                                id="password"
                                modelValue={formik.values.password}
                                onUpdateModelValue={(val) => formik.setFieldValue("password", val)}
                                validation={
                                    formik.errors.password &&
                                    formik.touched.password && {
                                        $error: true,
                                        required: { $invalid: true, $message: formik.errors.password },
                                    }
                                }
                            />
                        </div>

                        {/* CONFIRM PASSWORD */}
                        <div className="col-span-12 md:col-span-6">
                            <InputText
                                type="password"
                                label="પાસવર્ડ પુષ્ટિ કરો"
                                id="confirmPassword"
                                modelValue={formik.values.confirmPassword}
                                onUpdateModelValue={(val) =>
                                    formik.setFieldValue("confirmPassword", val)
                                }
                                validation={
                                    formik.errors.confirmPassword &&
                                    formik.touched.confirmPassword && {
                                        $error: true,
                                        required: {
                                            $invalid: true,
                                            $message: formik.errors.confirmPassword,
                                        },
                                    }
                                }
                            />
                        </div>

                        {/* SUBADMIN */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">સબ એડમિન</label>
                            <Select
                                style={{ width: "100%", height: "40px" }}
                                showSearch
                                allowClear
                                placeholder="સબ એડમિન પસંદ કરો"
                                value={formik.values.subAdmin}
                                filterOption={false}
                                status={
                                    formik.touched.subAdmin && formik.errors.subAdmin
                                        ? "error"
                                        : ""
                                }
                                onSearch={handleSubAdminSearch}
                                onPopupScroll={handleSubAdminScroll}
                                notFoundContent={fetchingSubAdmin ? <Spin size="small" /> : 'No data'}
                                onChange={(val) => formik.setFieldValue("subAdmin", val)}
                            >
                                {subAdmin.map((item: any) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.fullName}
                                    </Option>
                                ))}
                            </Select>
                            {formik.touched.subAdmin && typeof formik.errors.subAdmin === "string" && (
                                <small className="text-red-500">{formik.errors.subAdmin}</small>
                            )}
                        </div>

                        {/* UPLOAD PROFILE */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">પ્રોફાઇલ ચિત્ર</label>
                            <FileUpload
                                customUpload
                                chooseLabel="અપલોડ કરો"
                                mode="basic"
                                // accept="image/*"
                                // maxFileSize={2000000}
                                onSelect={async (e) => {
                                    const file = e.files[0];
                                    if (!file) return;

                                    try {
                                        const formData = new FormData();
                                        formData.append("file", file);

                                        const response = await apiFunctions.post(
                                            `/usermobile/mobile/uploadimage/userprofile?languageprefer=en`,
                                            formData,
                                            null,
                                            true
                                        );

                                        if (response?.data?.success) {
                                            const fileName = response.data.data.name;

                                            formik.setFieldValue("profilePic", fileName);

                                            showToast({
                                                severity: "success",
                                                summary: "Uploaded",
                                                detail: "Profile image uploaded successfully",
                                                life: 2000,
                                            });
                                        }
                                    } catch (err: any) {
                                        errorHandler(err);
                                    }
                                }}
                            />
                            {formik.touched.profilePic && typeof formik.errors.profilePic === "string" && (
                                <small className="text-red-500">{formik.errors.profilePic}</small>
                            )}
                        </div>

                        {/* IDENTITY FRONT */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">આઈડેન્ટિટી પ્રૂફ (ફ્રન્ટ)</label>
                            <FileUpload
                                customUpload
                                mode="basic"
                                chooseLabel="અપલોડ કરો"
                                // accept="image/*,.pdf"
                                // maxFileSize={2000000}
                                onSelect={async (e) => {
                                    const file = e.files[0];
                                    if (!file) return;

                                    try {
                                        const formData = new FormData();
                                        formData.append("file", file);

                                        const response = await apiFunctions.post(
                                            `/usermobile/mobile/uploadimage/userprofile?languageprefer=en`,
                                            formData,
                                            null,
                                            true
                                        );

                                        if (response?.data?.success) {
                                            const fileName = response.data.data.name;

                                            formik.setFieldValue("profilePic", fileName);

                                            showToast({
                                                severity: "success",
                                                summary: "Uploaded",
                                                detail: "Profile image uploaded successfully",
                                                life: 2000,
                                            });
                                        }
                                    } catch (err: any) {
                                        errorHandler(err);
                                    }
                                }}
                            // onSelect={(e) =>
                            //     formik.setFieldValue("identityFront", e.files[0])
                            // }
                            />
                        </div>

                        {/* IDENTITY BACK */}
                        <div className="col-span-12 md:col-span-6">
                            <label className="font-semibold">આઈડેન્ટિટી પ્રૂફ (બેક)</label>
                            <FileUpload
                                customUpload
                                mode="basic"
                                chooseLabel="અપલોડ કરો"
                                accept="image/*,.pdf"
                                maxFileSize={2000000}
                                onSelect={(e) =>
                                    formik.setFieldValue("identityBack", e.files[0])
                                }
                            />
                        </div>
                    </div>

                    <div className="mt-5">
                        <Button
                            label="સબમિટ કરો"
                            className="prime-button btn-login !w-full"
                            type="submit"
                        />
                    </div>
                </Card>
            </form>
        </div>
    );
};

export default RegistrationCreateGu;
